import { auth } from "@api/auth/path";
import { faculties } from "@api/faculties/path";
import { academicGroups } from "@api/academicGroup/path";
import { users } from "@api/users/path";
import { papers } from "@api/paper/path";
import { chats } from "@api/chats/path";
import { members } from "@api/members/path";
import { types } from "@api/selectTypes/path";
import { staffs } from "@api/staff/path";
import { file } from "@api/file/path";
import { system } from "@api/system/path";
import { candidates } from "@api/candidates/path";

export const apiPath = {
  auth,
  faculties,
  academicGroups,
  users,
  papers,
  chats,
  members,
  staffs,
  types,
  file,
  system,
  candidates,
};
